import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import {
    ICalendarScheduleFilters,
    IConfirmSchedulePayload,
    IUpdateSchedulePayload,
} from "../types/dashboard.types";

// Endpoint to fetch clinicians sessions summary
export async function fetchSessionSummary(
    providerId: string,
    customDate?: string
) {
    const response = await axios.get(`/${providerId}/session-summary`, {
        params: handleRemoveEmptyParamFromQueryParams({
            custom_date: customDate,
        }),
    });
    return response.data;
}

// Endpoint to fetch clinicians calendar schedule
export async function fetchProviderCalendar(filters: ICalendarScheduleFilters) {
    const response = await axios.get(
        `/${filters.providerId}/calendar?show_paused_clients=false`,
        {
            params: handleRemoveEmptyParamFromQueryParams(filters),
        }
    );
    return response.data;
}

// Endpoint to confirm provider schedule
export async function confirmSchedule(payload: IConfirmSchedulePayload) {
    const response = await axios.post(`/provider/sessions/confirm`, payload);
    return response.data;
}

export async function updateSchedule(payload: IUpdateSchedulePayload) {
    const response = await axios.post(`/provider/sessions/update`, payload);
    return response.data;
}
